import React from 'react';

import {
	ContextualInviteNudgeFlagLoadable,
	LIVE_PAGE_SOURCE,
} from '@confluence/contextual-invite-nudge-flag';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary';

import { useLivePageInviteNudgeStore } from './useLivePageInviteNudgeStore';

const LivePageInviteNudgeComponent = () => {
	const [{ hasLivePageChanges }] = useLivePageInviteNudgeStore();

	if (!hasLivePageChanges) {
		return null;
	}

	return <ContextualInviteNudgeFlagLoadable source={LIVE_PAGE_SOURCE} />;
};

export const LivePageInviteNudge = withTransparentErrorBoundary({
	attribution: Attribution.FLYWHEEL_ACTIVATION,
})(LivePageInviteNudgeComponent);
